import classes from "./IconBenefitGrid.module.css";

function renderHighlightedText(text, highlightWords) {
  if (!text) return null;

  const words = Array.isArray(highlightWords)
    ? highlightWords
    : [highlightWords];

  const validWords = words.filter(Boolean);

  if (!validWords.length) {
    return text;
  }

  const escapedWords = validWords.map((word) =>
    word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
  );

  const regex = new RegExp(`(${escapedWords.join("|")})`, "gi");

  return text.split(regex).map((part, index) => {
    const isHighlighted = validWords.some(
      (word) => part.toLowerCase() === word.toLowerCase(),
    );

    return isHighlighted ? (
      <span key={index} className={classes.highlight}>
        {part}
      </span>
    ) : (
      part
    );
  });
}

export default function IconBenefitGrid({
  title = "",
  highlightWords = [],
  description = "",
  items = [],
}) {
  return (
    <section className={classes.section}>
      <div className="container">
        <div className={classes.content}>
          {title && (
            <h2 className={classes.title}>
              {renderHighlightedText(title, highlightWords)}
            </h2>
          )}

          {description && (
            <p className={classes.description}>
              {description}
            </p>
          )}

          {items.length > 0 && (
            <div className={classes.grid}>
              {items.map((item, index) => {
                const Icon = item.icon;

                return (
                  <article className={classes.card} key={item.title || index}>
                    {Icon && (
                      <div className={classes.icon} aria-hidden="true">
                        <Icon />
                      </div>
                    )}

                    <div className={classes.cardContent}>
                      {item.title && (
                        <h3 className={classes.cardTitle}>{item.title}</h3>
                      )}

                      {item.description && (
                        <p className={classes.cardDescription}>
                          {item.description}
                        </p>
                      )}
                    </div>
                  </article>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
